<template>
    <v-footer
            dark
            height="auto"
            color="blue-grey darken-4"
    >
        <v-layout
                justify-center
                row
                wrap
        >

            <v-card
                    flat
                    tile
                    class="blue-grey darken-4"
            >
                <v-card-text>
                    <v-btn
                            v-for="(icon, i) in icons"
                            :key="i"
                            class="mx-1 white--text"
                            icon
                            :href="icon.link"
                    >
                        <v-icon size="24px">{{ icon.icon }}</v-icon>
                    </v-btn>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-text class="white--text text-center">
                  <a href="https://kimapp.cl" target="_blank">
                    <v-img :src="require('@/assets/img/logo_dark.png')" class="mx-auto" width="90" ></v-img>
                  </a>
                </v-card-text>
            </v-card>
        </v-layout>
    </v-footer>
</template>

<script>
    export default {
        name: 'WFooter',
        data(){
            return {
                icons: [
                  {icon: 'fab fa-facebook', link: 'https://www.facebook.com/KimApp-Software-de-Gesti%C3%B3n-M%C3%A9dica-353447955633889'},
                  {icon: 'fab fa-linkedin', link: 'https://www.linkedin.com/company/kimapp-software-para-centros-m%C3%A9dicos-y-profesionales-de-la-salud'},
                  {icon: 'fab fa-instagram', link: 'https://instagram.com/kimappsoftware'}
                ]
            }
        }
    }
</script>
